import { DateDisplay, ProfileDisplay } from "../../../components";
import { FixedCell } from "../../../components/tables/StandardTable";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import HubwiseJobStageInfoCell from "./HubwiseJobStageInfoCell";

const HubwiseJobTableRow = ({ data, index, style, ...rest }) => {
    if (index >= data.length || data[index] == null)
        return <TableLoadingRow />

    const {
        startedById,
        startedBy,
        runDate,
        totalElapsed,
        status,
        statusDescription,
        clientsFileName,
        holdingsFileName,
        insertedHoldings,
        upsertedClients,
        upsertedPlatformAccounts,
        importWarnings,
        filesProcessed,
        filesProcessedIn,
        generatedMatches,
        matchingWarnings,
        matchesGenerated,
        matchesGeneratedIn,
        generatedSubTransactions,
        generatedAddTransactions,
        generatedTransactions,
        transactionWarnings,
        transactionsGenerated,
        transactionsGeneratedIn,
        exception
    } = data[index];

    return <tr>
        <FixedCell className="text-truncate">
            <DateDisplay format="lll">{runDate}</DateDisplay>
        </FixedCell>
        <FixedCell className="text-truncate">
            <ProfileDisplay userId={startedById} userDisplayName={startedBy} />
        </FixedCell>
        <FixedCell className="text-truncate">
            {clientsFileName}
        </FixedCell>
        <FixedCell className="text-truncate">
            {holdingsFileName}
        </FixedCell>
        <FixedCell className="text-truncate">
            {statusDescription}
        </FixedCell>
        <FixedCell className="text-truncate">
            {status === 0 ? "-" : totalElapsed}
        </FixedCell>
        <HubwiseJobStageInfoCell
            className="text-truncate"
            stage="File Import"
            processCompleted={status !== 0}
            completed={filesProcessed}
            completedIn={filesProcessedIn}
            warnings={importWarnings}
            exception={!filesProcessed ? exception : null}
            info={<>
                <strong>Holdings:</strong> {insertedHoldings}<br />
                <strong>Clients:</strong> {upsertedClients}<br />
                <strong>Platform Accounts:</strong> {upsertedPlatformAccounts}
            </>}
        />
        <HubwiseJobStageInfoCell
            className="text-truncate"
            stage="Client Matching"
            processCompleted={status !== 0}
            completed={matchesGenerated}
            completedIn={matchesGeneratedIn}
            warnings={matchingWarnings}
            exception={filesProcessed && !matchesGenerated ? exception : null}
            info={<><strong>Matches:</strong> {generatedMatches}</>}
        />
        <HubwiseJobStageInfoCell
            className="text-truncate"
            stage="Transaction Generation"
            processCompleted={status !== 0}
            completed={transactionsGenerated}
            completedIn={transactionsGeneratedIn}
            warnings={transactionWarnings}
            exception={filesProcessed && matchesGenerated && !transactionsGenerated ? exception : null}
            info={<><strong>Transactions:</strong> {generatedTransactions} ({generatedAddTransactions} Add, {generatedSubTransactions} Sub)</>}
        />
    </tr>
}

export default HubwiseJobTableRow;